import { BaseUserProfile } from 'fitbeat.models';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { SafeAreaView, StyleSheet, View } from 'react-native';
import ActionSheet, { SheetManager } from 'react-native-actions-sheet';
import { connect } from 'react-redux';
import {
  addAvatarWillUnmount,
  choosePhotoPressed,
  nextPressed,
  onboardingCaptureAvatarDidMount,
  skipPressed,
  takePhotoPressed,
} from '../../auth/app-onboarding/capture-avatar-actions';
import { OnboardingScreenHeader } from '../../auth/app-onboarding/OnBordingScreenHeader';
import { styles as SharedStyles } from '../../auth/SignupFormsStyles';
import { Button, ButtonSize, ButtonTypes } from '../../components';
import { IAppStore } from '../../HomeWorkouts';
import Theme from '../../theme';
import { FormError } from '../../ui';
import { defaultScale, UserDataConsumer } from '../../utils';
import { AvatarPreviewEditButton } from './AvatarPreviewEditButton';

interface IProps {
  user: {
    userProfile: BaseUserProfile;
  };
  takePhotoPressed: (userId: string, hideActionPanel: () => void) => void;
  choosePhotoPressed: (userId: string, hideActionPanel: () => void) => void;
  loadingExistingAvatar: boolean;
  uploadedAvatar?: string;
  existingAvatar?: string;
  errorMessage?: string;
  addAvatarWillUnmount: () => void;
  actions: React.Component;
  nextPressed: (userId: string, navigation: any) => void;
  skipPressed: (navigation: any) => void;
  onboardingCaptureAvatarDidMount: (userId: string) => void;
  navigation: any;
  t: (key: string, options?: any) => string;
}

export class UpdateAvatar extends PureComponent<IProps> {
  private actionSheetId = 'avatar-capture-method-buttons';

  public componentDidMount() {
    const { user: { userProfile } } = this.props;
    this.props.onboardingCaptureAvatarDidMount(userProfile.uid);
  }

  public componentWillUnmount() {
    this.props.addAvatarWillUnmount();
  }

  public render() {
    const {
      t,
      user: { userProfile },
      errorMessage,
      uploadedAvatar,
      existingAvatar,
      loadingExistingAvatar,
      actions,
    } = this.props;
    return (
      <SafeAreaView style={{ flex: 1 }}>
        <OnboardingScreenHeader
          header={t('auth:appOnboardingAvatarHeader')}
          subheader={t('auth:appOnboardingAvatarSubHeader')}
        />

        <View style={{ flex: 1 }}>
          <AvatarPreviewEditButton
            onPress={this.showCaptureMethodPanel}
            base64Avatar={uploadedAvatar || existingAvatar}
            t={t}
            loading={loadingExistingAvatar}
          />
        </View>

        <View>
          {errorMessage &&
            <FormError
              error={new Error(errorMessage)}
            />
          }
          {actions}
        </View>

        <ActionSheet id={this.actionSheetId}>
          <View style={styles.actionSheetContainer}>
            <Button
              fontColor={Theme.WHITE}
              size={ButtonSize.MEDIUM}
              onPress={() => this.props.takePhotoPressed(userProfile.uid, this.hideCaptureMethodPanel)}
              title={t('auth:appOnboardingAvatarTakePhoto')}
            />
            <Button
              fontColor={Theme.PRIMARY}
              buttonType={ButtonTypes.OUTLINE}
              size={ButtonSize.MEDIUM}
              containerStyle={styles.bottomButton}
              onPress={() => this.props.choosePhotoPressed(userProfile.uid, this.hideCaptureMethodPanel)}
              title={t('auth:appOnboardingAvatarChoosePhoto')}
            />
          </View>
        </ActionSheet>
      </SafeAreaView>
    );
  }

  private showCaptureMethodPanel = async () => {
    await SheetManager.show(this.actionSheetId);
  }

  private hideCaptureMethodPanel = async () => {
    await SheetManager.hide(this.actionSheetId);
  }
}

const styles = StyleSheet.create({
  actionSheetContainer: {
    padding: defaultScale(15),
  },
  bottomButton: {
    marginTop: defaultScale(10),
  },
});

const mapStateToProps = (state: IAppStore) => ({
  errorMessage: state.auth.signup.uploadingAvatarErrorMessage,
  uploadedAvatar: state.auth.signup.uploadedAvatar,
  existingAvatar: state.auth.signup.existingAvatar,
  loadingExistingAvatar: state.auth.signup.loadingExistingAvatar,
});

const mapDispatchToProps = ({
  takePhotoPressed,
  choosePhotoPressed,
  nextPressed,
  skipPressed,
  onboardingCaptureAvatarDidMount,
  addAvatarWillUnmount,
});

export default translate(['auth'], { wait: true })(
  connect(mapStateToProps, mapDispatchToProps)(UserDataConsumer(UpdateAvatar)));
